import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import Icon from '../components/Icon';

const METRIC_TYPES = ['weight', 'reps', 'distance', 'time', 'body_measurement', 'custom'];

export default function Metrics() {
  const [templates, setTemplates] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [showAdd,   setShowAdd]   = useState(false);
  const [form,      setForm]      = useState({ exercise_name: '', metric_type: 'weight', unit: '' });
  const [saving,    setSaving]    = useState(false);

  useEffect(() => {
    api.get('/metrics').then(setTemplates).finally(() => setLoading(false));
  }, []);

  async function handleCreate(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const t = await api.post('/metrics', form);
      setTemplates(prev => [t, ...prev]);
      setForm({ exercise_name: '', metric_type: 'weight', unit: '' });
      setShowAdd(false);
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Delete this metric template? Clients who already have it will keep their history.')) return;
    await api.delete('/metrics/' + id);
    setTemplates(prev => prev.filter(t => t.id !== id));
  }

  return (
    <div>
      <div className="page-header">
        <h1>
          <Icon name="icon-chart.png" />
          Metrics
        </h1>
        <button className="icon-btn" onClick={() => setShowAdd(v => !v)}>
          <Icon name="icon-add.png" alt="Add" />
        </button>
      </div>

      <div className="page-content">
        {showAdd && (
          <div className="card" style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 12 }}>New Metric Template</div>
            <form onSubmit={handleCreate}>
              <div className="form-group">
                <label className="form-label">Metric Name *</label>
                <input className="form-input" placeholder="e.g. Bench Press, Body Weight, 5K Time"
                  value={form.exercise_name}
                  onChange={e => setForm(f => ({ ...f, exercise_name: e.target.value }))}
                  required autoFocus />
              </div>
              <div className="form-group">
                <label className="form-label">Type</label>
                <select className="form-select" value={form.metric_type}
                  onChange={e => setForm(f => ({ ...f, metric_type: e.target.value }))}>
                  {METRIC_TYPES.map(t => <option key={t} value={t}>{t.replace('_', ' ')}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Unit (optional)</label>
                <input className="form-input" placeholder="e.g. kg, lbs, km, mins"
                  value={form.unit}
                  onChange={e => setForm(f => ({ ...f, unit: e.target.value }))} />
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-primary" type="submit" disabled={saving} style={{ flex: 1 }}>
                  {saving ? 'Saving...' : 'Save Template'}
                </button>
                <button className="btn btn-ghost" type="button" style={{ flex: 1 }}
                  onClick={() => { setShowAdd(false); setForm({ exercise_name: '', metric_type: 'weight', unit: '' }); }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {loading ? (
          <div className="loading-spinner"><span className="spinner" /></div>
        ) : templates.length === 0 && !showAdd ? (
          <div className="empty-state">
            <Icon name="icon-chart.png" size={48} style={{ opacity: 0.3 }} />
            <p>No metric templates yet</p>
            <button className="btn btn-primary" style={{ width: 'auto', padding: '0 24px' }}
              onClick={() => setShowAdd(true)}>
              Create First Metric
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {templates.map(t => (
              <div key={t.id} className="card">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{t.exercise_name}</div>
                    <div style={{ fontSize: 13, color: 'var(--color-text-muted)', marginTop: 4, textTransform: 'capitalize' }}>
                      {t.metric_type.replace('_', ' ')}{t.unit ? ' · ' + t.unit : ''}
                    </div>
                  </div>
                  <button className="icon-btn" onClick={() => handleDelete(t.id)}>
                    <Icon name="icon-delete.png" alt="Delete" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
